export default __webpack_public_path__ + "static/media/Metropolis-Regular.c7106e4a.woff2";